import { logout } from 'redux/actions/user.actions'
import * as addonsActions from 'redux/actions/addons.actions'

const initialState = {
  owned: [],
  all: {}
}

function addonsReducer(state = initialState, { type, payload = {} }) {
  switch (type) {
    case addonsActions.getAddonsSuccess.type: {
      const addons = {}
      payload.data.forEach(item => {
        const {name, paymentLink, price, renewalFrequency, value} = item.attributes
        if (!addons[name]) {
          addons[name] = {
            renewalFrequency: renewalFrequency,
            variants: []
          }
        }
        addons[name].variants.push({price, paymentLink, value})
      })
      
      return {
        ...state,
        all: addons
      }
    }
    case addonsActions.getOwnedAddonsSuccess.type: {
      return {
        ...state,
        owned: payload?.data.map(item => ({
          id: item.id,
          ...(item.attributes || {}) 
        })) || []
      }
    }
    case logout.type:
      return initialState
    default:
      return state
  }
}
export default addonsReducer
